export default __webpack_public_path__ + "static/media/APACHE RR 310_1.48c0ec6e.webp";